import React, { useEffect } from 'react';
import { ChevronRight, Clock } from 'lucide-react';
export function ComingSoonPage({
  title
}: {
  title: string;
}) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <section className="bg-cream" data-id="element-208">
      <div className="bg-cream-dark border-b border-warmBorder" data-id="element-209">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-14" data-id="element-210">
          <nav className="flex items-center gap-2 text-sm text-warmGray mb-4" data-id="element-211">
            <a href="#/" className="hover:text-gold transition-colors" data-id="element-212">
              Home
            </a>
            <ChevronRight size={14} className="text-warmGray/50" data-id="element-213" />
            <span className="text-charcoal font-medium" data-id="element-214">{title}</span>
          </nav>
          <h1 className="text-3xl md:text-4xl font-serif text-charcoal" data-id="element-215">
            {title}
          </h1>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-24 md:py-32 text-center" data-id="element-216">
        <div className="w-20 h-20 mx-auto bg-gold/10 rounded-full flex items-center justify-center mb-8" data-id="element-217">
          <Clock className="w-10 h-10 text-gold" data-id="element-218" />
        </div>
        <h2 className="text-3xl md:text-4xl font-serif text-charcoal mb-4" data-id="element-219">
          Coming Soon
        </h2>
        <p className="text-warmGray text-lg leading-relaxed mb-10 max-w-md mx-auto" data-id="element-220">
          We're working on this page. In the meantime, feel free to browse our
          collection or get in touch with any questions.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-221">
          <a href="#/" className="inline-flex items-center justify-center px-8 py-3.5 bg-gold hover:bg-gold-light text-white font-bold rounded-sm transition-colors text-sm uppercase tracking-wider" data-id="element-222">
            Browse Switchplates
          </a>
          <a href="#/contact" className="inline-flex items-center justify-center px-8 py-3.5 border-2 border-warmBorder text-charcoal hover:border-gold hover:text-gold font-bold rounded-sm transition-colors text-sm uppercase tracking-wider" data-id="element-223">
            Contact Us
          </a>
        </div>
      </div>
    </section>;
}